import { useEffect, useState } from 'react'
import { getBranchName } from './api.js'

/**
 * Resuelve el NOMBRE de la sucursal (ej. "Zapopan") a partir del branchId de la
 * sesión, para que el comensal vea a qué sucursal está ordenando. El guest tiene
 * el branchId (de la sesión del QR) pero no el nombre; lo pide al endpoint público
 * `/v1/public/branch/:branchId`.
 *
 * Cache en módulo (Map): el nombre es estable y barato; no vale la pena
 * persistirlo. Devuelve null mientras carga o si falla (el header simplemente no
 * pinta la sucursal, sin romper).
 */
const cache = new Map<string, string>()

export function useBranchName(branchId: string | null | undefined): string | null {
  const [name, setName] = useState<string | null>(() => (branchId ? cache.get(branchId) ?? null : null))

  useEffect(() => {
    if (!branchId) { setName(null); return }
    const cached = cache.get(branchId)
    if (cached) { setName(cached); return }
    let alive = true
    void (async () => {
      const r = await getBranchName(branchId)
      if (!alive) return
      if (r.ok && r.data.name) {
        cache.set(branchId, r.data.name)
        setName(r.data.name)
      }
    })()
    return () => { alive = false }
  }, [branchId])

  return name
}
